import { render, staticRenderFns } from "./NewDocumentFormatSelector.vue?vue&type=template&id=6e380b92&scoped=true&"
import script from "./NewDocumentFormatSelector.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentFormatSelector.vue?vue&type=script&lang=ts&"
import style0 from "./NewDocumentFormatSelector.vue?vue&type=style&index=0&id=6e380b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e380b92",
  null
  
)

export default component.exports